import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpertSessionIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M17.4167 7.07034C17.4167 6.59074 17.4167 6.35094 17.3219 6.23989C17.2396 6.14354 17.1161 6.09241 16.9898 6.10235C16.8442 6.11381 16.6747 6.28338 16.3355 6.62251L13.4584 9.49967L16.3355 12.3768C16.6747 12.716 16.8442 12.8855 16.9898 12.897C17.1161 12.9069 17.2396 12.8558 17.3219 12.7595C17.4167 12.6484 17.4167 12.4086 17.4167 11.929V7.07034Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M1.58337 7.75801C1.58337 6.42788 1.58337 5.76282 1.84223 5.25478C2.06993 4.8079 2.43326 4.44457 2.88015 4.21687C3.38819 3.95801 4.05325 3.95801 5.38337 3.95801H9.65837C10.9885 3.95801 11.6536 3.95801 12.1616 4.21687C12.6085 4.44457 12.9718 4.8079 13.1995 5.25478C13.4584 5.76282 13.4584 6.42788 13.4584 7.75801V11.2413C13.4584 12.5715 13.4584 13.2365 13.1995 13.7446C12.9718 14.1915 12.6085 14.5548 12.1616 14.7825C11.6536 15.0413 10.9885 15.0413 9.65837 15.0413H5.38337C4.05325 15.0413 3.38819 15.0413 2.88015 14.7825C2.43326 14.5548 2.06993 14.1915 1.84223 13.7446C1.58337 13.2365 1.58337 12.5715 1.58337 11.2413V7.75801Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgExpertSessionIcon;
